$mol_icon_play_pause $mol_icon path \M3,5V19L11,12M13,19H16V5H13M18,5V19H21V5
